import MobileLayout from '../../layouts/MobileLayout';
import AbortContent from '../shared/AbortContent';
import { type AbortVariant } from '../../types';

type Props = {
  errorCode?: number;
  errorMessage?: string;
  variant?: AbortVariant;
  onReject?: () => void;
  onRestart?: () => void;
  onBack?: () => void;
};

export default function MobileAbortPage({ errorMessage: _, ...rest }: Props) {
  return (
    <MobileLayout>
      <AbortContent {...rest} buttonDirection="col" />
    </MobileLayout>
  );
}
